export default __webpack_public_path__ + "static/media/5.Square-Denim.23fe63d0.jpg";